import ViewPlanning from '../components/viewPlanning';
import { helpConsensus } from './variables/helpContent';
export default function Consensus() {
	return (
		<ViewPlanning
			planningType='consensus'
			helpContent={helpConsensus}
		/>
	);
}
